const prices = [
    { text: 'Từ 0 đến dưới 500.000đ', value: [0, 500000] },
    { text: 'Từ 500.000đ đến dưới 1.000.000đ', value: [500000, 1000000] },
    { text: 'Từ 1.000.000đ đến dưới 5.000.000đ', value: [1000000, 5000000] },
    { text: 'Từ 5.000.000đ trở lên', value: [5000000] },
];
export default prices;
